import React from "react";
import FooterLink from "./FooterLink";

const FooterSection = (item) => {
  return (
    <div
      className={`relative transition-all duration-300 lg:px-6 lg:px-0 py-3 lg:py-0 lg:bg-transparent`}
    >
      <div>
        {item.links.map((link) => {
          return <FooterLink {...link} key={link._uid}/>;
        })}
      </div>
    </div>
  );
};

export default FooterSection;
